import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';

import { actions as authActions } from '../modules/Auth/actions';
import { NAME as AUTH_NAME } from '../modules/Auth/reducer';
import { ChangePasswordDialog } from '../modules/Whatsapp/components/AccountMenu';
import ResetSeasonData from '../modules/Companies/components/ResetSeasonData';

// Цвета берём из темы Material-UI: переменные раздела рассылок (--wa-*) здесь не заданы.
const useStyles = makeStyles((theme) => ({
  login: {
    padding: theme.spacing(1.5, 2, 0),
    fontWeight: 600,
    fontSize: '14px',
    wordBreak: 'break-all',
  },
  error: { color: theme.palette.error.main, fontSize: '13px', marginTop: 8 },
  ok: { color: '#2e7d32', fontSize: '13px' },
  note: { color: theme.palette.text.secondary, fontSize: '12px', marginTop: 8, lineHeight: 1.45 },
}));

// Кто вошёл, смена пароля, обнуление площади, сбора и остатков и выход: внизу бокового меню.
function DrawerAccount({ login, logout }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <div>
      {login && <Typography className={classes.login}>{login}</Typography>}
      <List dense>
        <ListItem button onClick={() => setOpen(true)}>
          <ListItemIcon>
            <LockOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Сменить пароль" />
        </ListItem>
        <ResetSeasonData />
        <ListItem button onClick={() => logout()}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary="Выйти" />
        </ListItem>
      </List>
      {open && <ChangePasswordDialog classes={classes} onClose={() => setOpen(false)} />}
    </div>
  );
}

const mapStateToProps = (state) => ({ login: state[AUTH_NAME].login });

// Только выход: если привязать все действия, они заслонят свойство login.
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ logout: authActions.logout }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DrawerAccount);
